module.exports = __webpack_public_path__ + "img/maintenance-lotto.13e0160e.jpg";